import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const laboratoryConfidentialityDeedApi = {
    getLaboratoryConfidentialityDeedByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetLaboratoryConfidentialityDeedByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryConfidentialityDeedByLaboratoryId = new Dtos.GetLaboratoryConfidentialityDeedByLaboratoryId();
        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryConfidentialityDeedByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryConfidentialityDeedById: (id: number): Observable<Dtos.GetLaboratoryConfidentialityDeedByIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryConfidentialityDeedById = new Dtos.GetLaboratoryConfidentialityDeedById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryConfidentialityDeedByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setLaboratoryConfidentialityDeed: (laboratoryConfidentialityDeed: Dtos.LaboratoryConfidentialityDeed): Observable<Dtos.SetLaboratoryConfidentialityDeedResponse> => {

        let request: Dtos.SetLaboratoryConfidentialityDeed = new Dtos.SetLaboratoryConfidentialityDeed();

        request.laboratoryConfidentialityDeed = laboratoryConfidentialityDeed;

        // send request
        const response: Promise<Dtos.SetLaboratoryConfidentialityDeedResponse> = client.post(request);

        return Observable.from(response);
    },
    createLaboratoryConfidentialityDeed: (laboratoryId: number): Observable<Dtos.CreateLaboratoryConfidentialityDeedResponse> => {
        //Create the request.
        let request: Dtos.CreateLaboratoryConfidentialityDeed = new Dtos.CreateLaboratoryConfidentialityDeed();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateLaboratoryConfidentialityDeedResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteLaboratoryConfidentialityDeed: (id: number): Observable<Dtos.DeleteLaboratoryConfidentialityDeedResponse> => {
        //Create the request.
        let request: Dtos.DeleteLaboratoryConfidentialityDeed = new Dtos.DeleteLaboratoryConfidentialityDeed();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteLaboratoryConfidentialityDeedResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateLaboratoryConfidentialityDeed: (laboratoryConfidentialityDeed: Dtos.LaboratoryConfidentialityDeed): Observable<Dtos.ValidateLaboratoryConfidentialityDeedResponse> => {

        let request: Dtos.ValidateLaboratoryConfidentialityDeed = new Dtos.ValidateLaboratoryConfidentialityDeed();

        request.laboratoryConfidentialityDeed = laboratoryConfidentialityDeed;

        // send request
        const response: Promise<Dtos.ValidateLaboratoryConfidentialityDeedResponse> = client.post(request);

        return Observable.from(response);
    },
}